import React from 'react';
import useTranslate from '../../../../../customHooks/useTranslate';
import IconButton from '../../../../../muiComponents/IconButton';
import { useZitoneoSettings } from '../../../contexts/ZitoneoContentContext';
import {
    SuggestedURLState,
    URLAvailabilityStatus,
} from '../../../types/zitoneoServicesTypes';

interface SuggestedURLItemProps {
    url: SuggestedURLState;
}

const SuggestedURLItem = (props: SuggestedURLItemProps) => {
    const { url } = props;
    const translate = useTranslate();
    const { addUrl } = useZitoneoSettings();
    const isAvailable = url.status === URLAvailabilityStatus.AVAILABLE;

    return (
        <div className='settings__urls-item__suggested'>
            <p className='flex gap-5 flex-align-center'>
                <span className='settings__urls-item__separator'>/</span>
                {url.path}
            </p>
            <div className='flex gap-5 flex-align-center'>
                <p
                    className={`url-item__suggested-status ${
                        isAvailable ? '--available' : '--not-available'
                    }`}
                >
                    {translate(isAvailable ? 'available' : 'not_available')}
                </p>
                {isAvailable && (
                    <IconButton
                        iconName='Add'
                        onClick={() => addUrl(url.path)}
                    />
                )}
            </div>
        </div>
    );
};

export default SuggestedURLItem;
